import { createSlice } from "@reduxjs/toolkit";

const ServiceTypeSlice = createSlice({
  name: "servicetype",
  initialState: {
    servicetype: null,
    isLocationSwitchPopUpOpen: false,
    location: null,
    locationId: null,
    gender: [
      { gender: "Male", checked: true, value: "M" },
      { gender: "Female", checked: true, value: "F" },
    ],
    postalCode: null,
    insurance: null,
    distance: { from: 0, to: 30 },
    currentLocation: null,
    zipCode: "",
    allLocations: [],
    locationSource: null,
  },
  reducers: {
    ServiceTypeValue: (state, action) => {
      state.servicetype = action.payload;
    },
    updatezipCode: (state, action) => {
      state.zipCode = action.payload;
    },
    updateLocation: (state, action) => {
      state.location = action.payload ?? null;
    },
    updateAllLocation: (state, action) => {
      state.allLocations = action.payload;
    },
    updateCurrentLocation: (state, action) => {
      state.currentLocation = action.payload;
    },
    updateGender: (state, action) => {
      state.gender = action.payload;
    },
    updateLocationId: (state, action) => {
      state.locationId = action.payload;
    },
    updatePostalCode: (state, action) => {
      state.postalCode = action.payload;
    },
    updateInsurance: (state, action) => {
      state.insurance = action.payload;
    },
    updateDistance: (state, action) => {
      state.distance = action.payload;
    },
    updateIsLocationSwitchPopUpOpen: (state, action) => {
      state.isLocationSwitchPopUpOpen = action.payload;
    },
    updateLocationSource: (state, action) => {
      state.locationSource = action.payload ?? null;
    },
  },
});

export default ServiceTypeSlice.reducer;
export const {
  ServiceTypeValue,
  updateLocation,
  updateGender,
  updatePostalCode,
  updateInsurance,
  updateDistance,
  updateIsLocationSwitchPopUpOpen,
  updateCurrentLocation,
  updatezipCode,
  updateAllLocation,
  updateLocationSource,
} = ServiceTypeSlice.actions;
